<template>
  <div class="container">
    <img src="@/assets/images/download/251208.png" />
    <div class="btn" @click="bindToDownload"></div>
  </div>
</template>
<script>
export default {
  methods: {
    bindToDownload() {
      location.href = 'https://szdmall.suzhou.gov.cn/downloadtoapp'
    }
  }
}
</script>
<style scoped lang="stylus">
.btn {
  width: 450px;
  height: 70px;
  position: absolute;
  top: 1032px;
  left: 150px;
}
</style>
